import { EnumBase } from 'hay-core-react';
class LinkStatusEnum extends EnumBase {
  constructor() {
    super(
      [
        'main.link.status.aguardandoinicio',
        'main.link.status.iniciado',
        'main.link.status.finalizado',
      ],
      'main.link.status.aguardandoinicio'
    );
  }
}

export default new LinkStatusEnum();
